var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedInBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "45px",
    height: "45px",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1592 3632 c-61 -22 -114 -69 -145 -127 -30 -56 -30 -164 0 -220 50 -95 126 -139 243 -139 91 -1 140 15 192 62 61 55 82 104 82 187 0 77 -19 127 -70 179 -67 68 -202 93 -302 58z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2997 2959 c-96 -23 -189 -84 -258 -171 l-39 -50 0 101 0 101 -245 0 -245 0 0 -735 0 -735 245 0 245 0 0 453 0 454 31 61 c35 70 83 115 148 137 129 44 259 -16 307 -141 17 -45 19 -88 22 -506 l3 -458 245 0 245 0 -3 503 c-4 478 -5 506 -26 580 -60 215 -189 353 -379 402 -63 16 -234 19 -296 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1450 2205 l0 -735 245 0 245 0 0 735 0 735 -245 0 -245 0 0 -735z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInBlack);
export default __webpack_public_path__ + "static/media/linked-in-black.1d269ecf.svg";
export { ForwardRef as ReactComponent };